import {
  AuthState,
  AuthActionTypes,
  LOGIN,
  LOGOUT,
  LOGGED_IN,
  LOGGABLE,
  LOGGABLE_SUCESS,
  LOGIN_FAIL,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_RESET,
  FINALIZE_REGISTRATION_STATUS
} from './types'

export const initialAuthState: AuthState = {
  loading: false,
  logged: false, // false
  registered: false,
  loginfailure: false,
  error: '',
  forgotPasswordLoading: false,
  forgotPasswordSuccess: false,
  forgotPasswordFailure: false,
  finalizeRegistrationStatus: 'pending'
}

const AuthReducer = (
  state = initialAuthState,
  action: AuthActionTypes
): AuthState => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        loading: true,
        logged: false,
        loginfailure: false
      }

    case LOGGED_IN:
      return {
        ...state,
        loading: false,
        logged: true,
        loginfailure: false
      }
    case LOGOUT:
      return {
        ...state,
        loading: false,
        logged: false,
        loginfailure: false
      }
    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        logged: false,
        loginfailure: true
      }

    case LOGGABLE:
      return {
        ...state,
        loading: true,
        registered: false
      }

    case LOGGABLE_SUCESS:
      return {
        ...state,
        loading: false,
        registered: action.payload.loggable
      }

    case FORGOT_PASSWORD:
      return {
        ...state,
        forgotPasswordLoading: true
      }
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccess: true,
        forgotPasswordFailure: false,
        error: ''
      }
    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccess: false,
        forgotPasswordFailure: true,
        error: action.payload.error
      }

    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        error: action.payload.error
      }

    case FORGOT_PASSWORD_RESET:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccess: false,
        forgotPasswordFailure: false
      }
    case FINALIZE_REGISTRATION_STATUS:
      return {
        ...state,
        finalizeRegistrationStatus: action.payload.finalizeRegistrationStatus
      }

    default:
      return state
  }
}

export default AuthReducer
